import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../src/environments/environment';
import { ArcAngelData, ForeverEntities, Org } from '../models/plugin-config';
import { Organization } from '../models/model';
import { ConfigurationManagerService } from './configuration-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ArcAngelTincanService {
   data: ArcAngelData = {
    isSuperUser: false,
    isOrgAdmin: false,
    isMSPAdmin: false,
    isMultiAgencyAdmin: false,
    myOrgs: {},
    myResponseRightOrgs: {},
    myBuildings: [],
    fixCameraOnFacility: false,
    myFacilityPins: {},
    myGeofencesByIncidentId: {},
    myRemotePins: {},
    myTravelerPins: {},
    myBluetoothFacilityPins: {},
    myPerimeters: {},
    myBeacons: {},
    mySensors: {},
    mySensorFeeds: {},
    myMessages: {},
    myIncidentTypes: {},
    mySOPs: {},
    perimeterAreaMap: {},
    calls: 0,
    myAllUsers: []
  };
  private foreverEntitiesAdded: ForeverEntities = {
    perimeters: {},
    facilities: {},
    remotes: {},
    areas: {}
  };
  constructor(private http: HttpClient) {}


  assignData(value: Partial<ArcAngelData>): ArcAngelData {
    if (value) {
      this.data = { ...this.data, ...value };
    }
    return this.data;
  }

  startForeverPoller() {
    return this.foreverPoller();
  }

  stopForeverPoller(): void {
    // Implementation for stopping the poller
  }

  showNonBuildingPerimeters(): void {
    Object.values(this.foreverEntitiesAdded.perimeters).forEach(perimeter => {
      if (!perimeter.getIsPartOfBuilding()) {
        perimeter.show();
      }
    });
  }

  hideNonBuildingPerimeters(): void {
    Object.values(this.foreverEntitiesAdded.perimeters).forEach(perimeter => {
      if (!perimeter.getIsPartOfBuilding()) {
        perimeter.hide();
      }
    });
  }

  clearPerimeters(): void {
    // Implementation for clearing perimeters
  }

  get3dFacility(id: string): any {
    return this.foreverEntitiesAdded.facilities[id];
  }

  showBuildings(): void {
    this.data.myBuildings.forEach(building => {
      building.showFloors();
    });
  }

  showOnlyMyBuilding(buildingId: string): void {
    this.data.myBuildings.forEach(building => {
      if (building.getBuildingId() === buildingId) {
        building.showFloors();
      } else {
        building.hideFloors();
      }
    });
  }

  setBuildingIncident(incident: any): void {
    this.data.myBuildings.forEach(building => {
      if (building.isIncidentABuildingIncident(incident)) {
        building.addIncident(incident);
      }
    });
  }

  getAffectedPerimeterEntities(affectedPerimeters: any[]): any[] {
    const list: any[] = [];

    if (affectedPerimeters) {
      affectedPerimeters.forEach(perimeter => {
        const perimeterEntity = this.foreverEntitiesAdded.perimeters[perimeter.perimeterId];
        if (perimeterEntity) {
          list.push(perimeterEntity);
        }
      });
    }

    return list;
  }

  getPerimeter(perimeterId: string): any {
    if (perimeterId) {
      return this.foreverEntitiesAdded.perimeters[perimeterId];
    }
    return undefined;
  }

  getArea(areaId: string): any {
    if (areaId) {
      return this.foreverEntitiesAdded.areas[areaId];
    }
    return undefined;
  }

  private foreverPoller() {
    const urlCalls = [
      this.http.get(`${ConfigurationManagerService.settings.BaseURL}/me/profile`),
      this.http.get(`${ConfigurationManagerService.settings.BaseURL}/incidentType`),
      this.http.get(`${ConfigurationManagerService.settings.BaseURL}/sop`)
    ];

    
  }
    createAttachmentUrl(fileExtension: string, fileType: string): Observable<any> {
      const s3link = `${ConfigurationManagerService.settings.BaseURL}/me/s3/${fileExtension}?contentType=${fileType}`;
      return this.http.get(s3link);
    }
  
    putDataInS3(signeds3Url: string, dataToUpload: any, fileType: string): Observable<void> {
      return new Observable(subscriber => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', signeds3Url, true);
        xhr.setRequestHeader('Content-Type', fileType);
        xhr.onload = () => {
          if (xhr.status === 200) {
            subscriber.next();
            subscriber.complete();
          } else {
            subscriber.error(xhr.status);
          }
        };
        xhr.onerror = () => subscriber.error(xhr.status);
        xhr.send(dataToUpload);
      });
    }
  
    createUpdate(eventId: string, description: string, lat: number, lon: number, attachment?: any): Observable<any> {
      const newUpdate = {
        description,
        geometry: {
          type: 'Point',
          coordinates: [lon, lat]
        }
      };
  
      if (attachment) {
       // newUpdate['attachment'] = attachment;
      }
  
      return this.http.post(`${ConfigurationManagerService.settings.BaseURL}/event/${eventId}/update`, newUpdate);
    }
  
    createNotification(
      profileIds: string[],
      sendingOrg: string,
      title: string,
      body: string,
      attachments: any[],
      data: boolean,
      sms: boolean,
      email: boolean
    ): Observable<any> {
      const urlCalls: Observable<any>[] = [];
  
      if (data) {
        const newDataNotification = {
          profileIds,
          organizationIDs: [],
          title,
          body
        };
  
        if (attachments?.length > 0) {
         // newDataNotification['attachments'] = attachments;
        }
  
        if (sendingOrg) {
         // newDataNotification['sendingOrganization'] = sendingOrg;
        }
  
        urlCalls.push(this.http.post(`${ConfigurationManagerService.settings.BaseURL}/notification`, newDataNotification));
      }
  
      if (sms || email) {
        const newBulkNotification = {
          profileIds,
          messageSubject: title,
          sendingOrganization: sendingOrg
        };
  
        if (sms) {
        //  newBulkNotification['smsMessageBody'] = body.substring(0, 160);
        }
        if (email) {
        //  newBulkNotification['txtMessageBody'] = body;
         // newBulkNotification['htmlMessageBody'] = body;
        }
  
        urlCalls.push(this.http.post(`${ConfigurationManagerService.settings.BaseURL}/notification/bulk/users`, newBulkNotification));
      }
  
      return forkJoin(urlCalls);
    }
  
    createSafeZone(eventId: string, name: string, description: string, lat: number, lon: number): Observable<any> {
      const newSafeZone = {
        label: name,
        description,
        isActive: true,
        geometry: {
          type: 'Point',
          coordinates: [lon, lat]
        }
      };
  
      return this.http.post(`${ConfigurationManagerService.settings.BaseURL}/event/${eventId}/safezone`, newSafeZone, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).pipe(
        catchError(error => {
          console.error('Error creating new safe zone.', error);
          return throwError(() => error);
        })
      );
    }
  
    updateStatusOfEvent(eventId: string, status: string): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${eventId}`;
      const statusObj = { status };
      return this.http.put(url, statusObj);
    }
  
    updateEventDetails(obj: any, name: string, description: string, status: string, medGeo?: any, lowGeo?: any): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${obj.id}`;
      const details = { ...obj };
      delete details.updatedAt;
      details.label = name;
      details.description = description;
      details.status = status;
  
      if (medGeo) {
        details.mediumGeometry = {
          type: 'Polygon',
          coordinates: [this.flipLocations(medGeo)]
        };
      }
  
      if (lowGeo) {
        details.lowGeometry = {
          type: 'Polygon',
          coordinates: [this.flipLocations(lowGeo)]
        };
      }
  
      return this.http.put(url, details);
    }
  
    deleteEvent(eventId: string): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${eventId}`;
      return this.http.delete(url);
    }
  
    updateSafeZone(eventId: string, safezoneId: string, name: string, description: string, isActive: boolean, lat: number, lon: number): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${eventId}/safezone/${safezoneId}`;
      const safezone = {
        label: name,
        description,
        isActive,
        geometry: {
          type: 'Point',
          coordinates: [lon, lat]
        }
      };
  
      return this.http.put(url, safezone);
    }
  
    deleteSafeZone(eventId: string, safezoneId: string): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${eventId}/safezone/${safezoneId}`;
      return this.http.delete(url);
    }
  
    updateEventUpdate(eventId: string, updateId: string, description: string, isPublic: boolean): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/event/${eventId}/update/${updateId}`;
      const event = {
        description,
        isPublic
      };
      return this.http.put(url, event);
    }
  
    private flipLocations(locations: any[]): any[] {
      return locations.map(loc => [loc[1], loc[0]]);
    }
  
    private getMySOPs(orgId: string, SOPs: Record<string, any>): any[] {
      const mySOPs: any[] = [];
      Object.values(SOPs).forEach(sop => {
        if (sop.organization === orgId) {
          mySOPs.push(sop);
        }
      });
      return mySOPs;
    }
  
    private getMyMSPOrg(orgs: Record<string, Organization>): Organization | undefined {
      for (const org of Object.values(orgs)) {
       // if (org.type.toLowerCase() === 'msp') {
          return org;
       // }
      }
      return undefined;
    }
  
    private getOrgObjects(org: Organization): Observable<any> {
      const postdata = {
        organizationId: org.getId()
      };
  
      const urls = {
        groups: `${ConfigurationManagerService.settings.perimeters}/groups/findByOrganization`,
        departments: `${ConfigurationManagerService.settings.perimeters}/departments/findByOrganization`,
        businessUnits: `${ConfigurationManagerService.settings.perimeters}/businessUnits/findByOrganization`,
        entityLocations: `${ConfigurationManagerService.settings.perimeters}/locations/findByOrganization`
      };
  
      const urlCalls = Object.entries(urls).map(([id, url]) => 
        this.http.post(url, postdata).pipe(
          catchError(error => {
           // console.error(`Error getting organization object ${id} for ${org.getTitle()}`, error);
            return of({ data: {} });
          })
        )
      );
  
      return forkJoin(urlCalls).pipe(
        switchMap(results => {
          const perimeterPromises: Observable<any>[] = [];
          const [groups, departments, units, entityLocations] = results;
  
          // org.setGroups(groups.data);
          // org.setDepartments(departments.data);
          // org.setUnits(units.data);
          // org.setEntityLocations(entityLocations.data);
  
          // entityLocations.forEach((entityLocation: any) => {
          //   if (entityLocation.locationType === 'facility') {
          //     if (entityLocation.geometry?.coordinates) {
          //       const facilityPin = new FacilityPinMapEntity(
          //         entityLocation.label,
          //         entityLocation.geometry.coordinates[1],
          //         entityLocation.geometry.coordinates[0],
          //         entityLocation
          //       );
  
          //       if (entityLocation.attributes?.bluetooth) {
          //         this.data.myBluetoothFacilityPins[entityLocation.attributes.facilityId] = facilityPin;
          //       }
  
          //       this.data.myFacilityPins[entityLocation.id] = facilityPin;
  
          //       if (facilityPin.getBasePerimeterId()) {
          //         perimeterPromises.push(this.getPerimeterFromAPI(org.getId(), facilityPin.getBasePerimeterId()));
          //       }
          //     }
          //   } else if (entityLocation.locationType === 'remote') {
          //     if (entityLocation.attributes?.userId) {
          //       const remotePin = new RemotePinMapEntity(
          //         entityLocation.label,
          //         entityLocation.geometry.coordinates[1],
          //         entityLocation.geometry.coordinates[0],
          //         entityLocation
          //       );
  
          //       this.data.myRemotePins[entityLocation.id] = remotePin;
          //       // DataContext.addMapEntity(remotePin);
          //     }
          //   }
          // });
  
          return forkJoin(perimeterPromises);
        })
      );
    }
  
    getPerimeterFromAPI(orgId: string, perimeterId: string): Observable<any> {
      const url = `${ConfigurationManagerService.settings.BaseURL}/organization/${orgId}/perimeters/${perimeterId}`;
      return this.http.get(url);
    }
  } 
//     return forkJoin(urlCalls).pipe(
//       switchMap(([profile, incidentTypes, sops]) => {
//         const profileData = profile as any;
//         this.data.myName = profileData.attributes.name;
//         this.data.myId = profileData.id;
//         this.data.myEmail = profileData.attributes.email;
//         this.data.myPermissions = this.stringArrayToMap(profileData.permissions);
//         this.data.isSuperUser = 'SUPERUSER' in this.data.myPermissions;
//         this.data.isOrgAdmin = Object.keys(this.data.myPermissions).toString().includes('ORG_ADMIN');
//         this.data.isMSPAdmin = Object.keys(this.data.myPermissions).toString().includes('MSP_ADMIN');

//         if (profileData.attributes.view === 'facility') {
//           if (profileData.attributes.workFacility) {
//             this.data.myFacilityViewId = profileData.attributes.workFacility.id;
//             this.data.fixCameraOnFacility = true;
//           }
//         }

//         const incidentTypesData = incidentTypes as any;
//         incidentTypesData.items.forEach((value: any) => {
//           this.data.myIncidentTypes[value.id] = value;
//         });

//         const sopsData = sops as any;
//         sopsData.items.forEach((value: any) => {
//           this.data.mySOPs[value.incidentType] = value;
//         });

//         return this.organizationsPoller(profileData.organizations);
//       }),
//       catchError(error => {
//         console.error('Error retrieving profile, perimeters, organizations, and buildings.', error);
//         return throwError(() => error);
//       })
//     );
//   }

//   private organizationsPoller(organizations: string[]): Observable<void> {
//     const organizationPromises = organizations.map(orgId => 
//       this.http.get(`${ConfigurationManagerService.settings.BaseURL}/organization/${orgId}`)
//     );

//     return forkJoin(organizationPromises).pipe(
//       switchMap(organizationResponses => {
//         const organizationObjectPromises = organizationResponses.map(response => {
//           const orgData = (response as any).items[0];
//           const mySOPs = this.getMySOPs(orgData.id, this.data.mySOPs);
//           const organization = new Organization(
//             orgData.id,
//             orgData.attributes.name,
//             orgData.type,
//             orgData.attributes.contact,
//             orgData.created,
//             orgData.updated,
//             orgData.safezones,
//             orgData.perimeterIds,
//             orgData.facilities,
//             orgData.perimeters,
//             mySOPs,
//             orgData
//           );

//           this.data.myOrgs[orgData.id] = organization;

//           const geofences = organization.getGeofences();
//           if (geofences && geofences.length > 0) {
//             geofences.forEach((geofence: any) => {
//               geofence.orgId = organization.getId();
//               this.data.myGeofencesByIncidentId[geofence.incidentId] = geofence;
//             });
//           }

//           return this.getOrgObjects(organization);
//         });

//         this.data.myMSPOrg = this.getMyMSPOrg(this.data.myOrgs);
//         if (this.data.myMSPOrg) {
//           this.data.myFirstOrg = this.data.myMSPOrg;
//         }

//         return forkJoin(organizationObjectPromises);
//       })
//     );
//   }

//   private stringArrayToMap(permissions: string[]): Record<string, boolean> {
//     const map: Record<string, boolean> = {};
//     permissions.forEach(permission => {
//       map[permission] = true;
//     });
//     return map;
//   }
//   private getMySOPs(orgId: any, SOPs: Record<string, any>){
//     var mySOPs: any[] = [];
//     _.forEach(SOPs, (sop) => {
//       if(sop.organization === orgId){
//         mySOPs.push(sop);
//       }
//     });
//     return mySOPs;
//   }
//   // Add other private helper methods and remaining public methods as needed
//   // Convert each method to use RxJS Observables and proper typing
// } 
